module.exports = __webpack_public_path__ + "static/img/IMG_20240208_155433.496aafbd.jpg";